import { normalizeMarketingConfig } from "./normalizer";

export const EL_CORRAL_FANS_CAMPAIGN_ID = "local-fans-el-corral";
export const EL_CORRAL_FANS_REVISION = "fans-el-corral-2026-09-v1";
export const EL_CORRAL_FANS_FEATURE_PARAM = "fanselcorral";
export const EL_CORRAL_FANS_TARGET =
  "https://www.elcorral.com/others/fans-elcorral?catalogueId=1";


export const EL_CORRAL_DRACULA_CAMPAIGN_ID = "local-el-corral-dracula";
export const EL_CORRAL_DRACULA_REVISION = "el-corral-dracula-2026-09-v1";
export const EL_CORRAL_DRACULA_FEATURE_PARAM = "elcorraldracula";
export const EL_CORRAL_DRACULA_TARGET =
  "https://www.elcorral.com/others/fans-elcorral?catalogueId=1";

const FEATURE_ENABLED_VALUES = new Set(["1", "true", "on"]);
const PREVIEW_FREQUENCY = {
  scope: "session",
  maxImpressions: Number.MAX_SAFE_INTEGER,
  cooldownSeconds: 0,
};

const elCorralFansConfig = normalizeMarketingConfig({
  schemaVersion: 1,
  enabled: true,
  revision: EL_CORRAL_FANS_REVISION,
  defaults: {
    frequency: {
      scope: "user_day",
      maxImpressions: 8,
      cooldownSeconds: 10800,
    },
    target: {
      openIn: "new_tab",
    },
  },
  campaigns: [
    // {
    //   id: EL_CORRAL_FANS_CAMPAIGN_ID,
    //   enabled: true,
    //   priority: 1000,  
    //   triggers: [{ type: "page_view", delaySeconds: 1 }],
    //   creatives: [
    //     {
    //       id: "fans-el-corral-popup",
    //       format: "popup",
    //       asset: {
    //         type: "image",
    //         src: "/banners/fans-el-corral.jpg",
    //         alt: "Fans El Corral",
    //       },
    //       target: {
    //         href: EL_CORRAL_FANS_TARGET,
    //         openIn: "new_tab",
    //       },
    //       dismissible: true,
    //       stopAfterClickSeconds: 259200,
    //       showCloseAfterSeconds: 0,
    //     },
    //   ],
    // },
    {
      id: EL_CORRAL_DRACULA_CAMPAIGN_ID,
      enabled: true,
      priority: 1000,
      validFrom: "2026-09-01T00:00:00-05:00",
      validTo: "2026-10-31T23:59:59-05:00",
      triggers: [{ type: "page_view", delaySeconds: 1 }],
      creatives: [
        {
          id: "el-corral-dracula",
          format: "popup",
          asset: {
            type: "image",
            src: "/banners/el-corral-dracula.jpg",
            alt: "El Corral Drácula",
          },
          dismissible: true,
          stopAfterClickSeconds: 259200,
          showCloseAfterSeconds: 0,
        },
      ],
    },
  ],
});

const normalizeRadioName = (radioName) =>
  typeof radioName === "string"
    ? radioName
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase()
    : "";

export const isElCorralRadio = (radioName) =>
  normalizeRadioName(radioName).includes("el corral");

export const isElCorralFansFeatureEnabled = (search) => {
  const params =
    search instanceof URLSearchParams
      ? search
      : new URLSearchParams(typeof search === "string" ? search : "");
  const value = params.get(EL_CORRAL_FANS_FEATURE_PARAM);

  return FEATURE_ENABLED_VALUES.has(value?.trim().toLowerCase());
};

const isNormalizedConfig = (config) =>
  !!config && Array.isArray(config.campaigns) && Array.isArray(config.errors);

export const buildRadioMarketingConfig = ({
  config,
  radioName,
  enableElCorralFans = true,
  bypassFrequency = false,
}) => {
  const baseConfig = isNormalizedConfig(config)
    ? config
    : normalizeMarketingConfig(config);

  if (!enableElCorralFans || !isElCorralRadio(radioName)) return baseConfig;

  const backendCampaigns = baseConfig.enabled
    ? baseConfig.campaigns.filter(
      (campaign) => campaign.id !== EL_CORRAL_FANS_CAMPAIGN_ID &&
       campaign.id !== EL_CORRAL_DRACULA_CAMPAIGN_ID
    )
    : [];
  const elCorralCampaigns = bypassFrequency
    ? elCorralFansConfig.campaigns.map((campaign) => ({
      ...campaign,
      creatives: campaign.creatives.map((creative) => ({
        ...creative,
        frequency: PREVIEW_FREQUENCY,
        stopAfterClick: false,
        stopAfterClickSeconds: null,
      })),
    }))
    : elCorralFansConfig.campaigns;
  const campaigns = [
    ...elCorralCampaigns,
    ...backendCampaigns,
  ].sort((a, b) => b.priority - a.priority);
  const localRevision = bypassFrequency
    ? `${EL_CORRAL_FANS_REVISION}-preview`
    : EL_CORRAL_FANS_REVISION;

  return {
    ...elCorralFansConfig,
    schemaVersion: Math.max(
      elCorralFansConfig.schemaVersion,
      baseConfig.schemaVersion ?? 1
    ),
    revision: baseConfig.enabled
      ? `${baseConfig.revision}+${localRevision}`
      : localRevision,
    defaults: baseConfig.enabled
      ? baseConfig.defaults
      : elCorralFansConfig.defaults,
    campaigns,
    errors: baseConfig.errors ?? [],
  };
};
